import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'da',
    fullName: 'Danish',
    nativeName: 'Dansk',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Noget fantastisk er på vej",
    landing_subtitle: "ArgVoid er et app- og spiludviklingsstudie. Følg med, der kommer snart nye ting!",
    select_language: "Vælg sprog",
    search_placeholder: "Søg efter sprog...",
    terms_title: "Servicevilkår",
    policy_title: "Privatlivspolitik",
    cookies_title: "Cookiepolitik",
    terms_content: `
        <strong>1. Accept af Vilkår</strong><br>
        Ved at tilgå ArgVoid accepteres disse Servicevilkår. Hvis disse vilkår ikke er aftalt, bør tjenesten ikke bruges.<br><br>

        <strong>2. Platformbrug</strong><br>
        ArgVoid og dets applikationer leveres "som de er" til informationsmæssige og kreative formål. Tjenesten må kun bruges til lovlige formål.<br><br>

        <strong>3. Forbudt adfærd</strong><br>
        Udnyttelse af webstedssårbarheder, spamming eller forsøg på uautoriseret adgang til infrastrukturen er strengt forbudt.<br><br>

        <strong>4. Ansvarsfraskrivelse</strong><br>
        Platformen og tjenesterne kan til enhver tid ændres uden varsel. Der ydes ingen garanti vedrørende oppetiden eller tilgængeligheden af ​​tjenesten.
    `,
    policy_content: `
        <strong>1. Informationssamling</strong><br>
        Platformen kræver ikke brugergodkendelse eller kontooprettelse på nuværende tidspunkt. Ingen personlig identificerende information (såsom navne eller e-mailadresser) indsamles aktivt fra besøgende.<br><br>

        <strong>2. Brug Data</strong><br>
        Grundlæggende, anonymiserede analyser kan indsamles for at forstå trafik på webstedet og forbedre applikationerne. Disse data er ikke knyttet til individuelle brugeridentiteter.<br><br>

        <strong>3. Tredjepartstjenester</strong><br>
        Tredjepartsudbydere kan blive brugt til hosting- og analysetjenester. Disse respektive udbyderes privatlivspraksis styrer de anonyme data, der behandles på deres infrastruktur.<br><br>

        <strong>4. Datasikkerhed</strong><br>
        Rimelige sikkerhedsforanstaltninger er implementeret for at beskytte platformen. Ingen transmissionsmetode over internettet er dog helt sikker.<br><br>
    `,
    cookies_content: `
        <strong>1. Hvad er cookies og lokal lagring?</strong><br>
        Cookies og lokal lagring i browseren er små datafiler, der er gemt på enheden for at huske konfigurationspræferencer på tværs af besøg.<br><br>

        <strong>2. Brugsformål</strong><br>
        Browser LocalStorage bruges udelukkende til at gemme konfigurationsindstillinger, såsom:<br>
        - Sprogpræferencer<br>
        - Brugergrænsefladekonfiguration (f.eks. layout eller temaindstillinger) <br>
        - Midlertidig applikationscache<br><br>

        <strong>3. Ingen sporing</strong><br>
        Cookies og lokal lagring bruges ikke til reklame- eller tredjepartsformål. Alle lagrede data er udelukkende for platformens kernefunktionalitet.<br><br>

        <strong>4. Kontrol</strong><br>
        Browserdata kan til enhver tid ryddes gennem browserindstillingerne, som vil nulstille alle lokale konfigurationer.
    `,
    cookie_consent_text: "Vi bruger grundlæggende cookies for at sikre, at hjemmesiden fungerer korrekt, såsom at holde din session aktiv, gemme dine sprogpræferencer og andre brugerdefinerede konfigurationer.",
    read_policy: "Læs Cookiepolitik",
    support_title: "Kontakt support",
    support_subject_label: "Emne",
    support_message_label: "Besked",
    support_submit_button: "Send besked",
    support_hint: "Bemærk: Dette åbner dit standard e-mailprogram til at sende beskeden.",
    support_success_msg: "Åbner din e-mail-app...",
    support_error_msg: "Kunne ikke sende besked. Prøv venligst igen senere.",
    explorer_title: "Explorer",
    history_title: "Historie",
    animation_title: "Animation",
    config_title: "Konfiguration",
    tool_mouse: "Vælg (Ctrl+M)",
    tool_brush: "Pensel (Ctrl+B)",
    tool_brush_mode: "Til/fra-tilstand (fast/klar)",
    tool_eraser: "Viskelæder (Ctrl+E)",
    tool_brush_size: "Juster børstestørrelsen",
    tool_bucket: "Udfyld (Ctrl+F)",
    tool_eyedropper: "Pipette",
    tool_grid: "Gitter (Ctrl+Shift+B)",
    tool_rotate: "Roter (Ctrl+Shift+R)",
    tool_flip_h: "Vend H (Ctrl+Shift+H)",
    tool_flip_v: "Vend V (Ctrl+Shift+V)",
    tool_transpose: "Transponer (Ctrl+Shift+T)",
    label_width: "Bredde",
    label_height: "Højde",
    label_frames: "Antal rammer",
    label_animation: "Animation stil",
    label_background_color: "Baggrundsfarve",
    label_interval: "Interval",
    tool_anim_config: "Animationskonfiguration",
    label_new_width: "Ny bredde",
    label_new_height: "Ny højde",
    label_apply: "Anvende",
    label_colors: "Farver",
    label_size: "Størrelse",
    label_tolerance: "Tolerance",
    val_horizontal: "Vandret",
    val_vertical: "Lodret",
    val_sequence: "Sekvens",
    val_bounce: "Bounce",
    val_random: "Tilfældig",
    val_solid: "Solid",
    val_clear: "Klar",
    action_add_sheet: "Nyt ark",
    action_import: "Importere",
    action_export: "Eksportere",
    action_sort_projects: "Sortere",
    sort_date_old: "Ældste først",
    sort_date_new: "Nyeste først",
    sort_name_az: "Navn (A-Z)",
    sort_name_za: "Navn (Z-A)",
    action_new_sprite: "Ny Sprite",
    action_new_project: "Nyt projekt",
    modal_save_all_title: "Gem alle ændringer",
    modal_save_all_desc: "Vælg de aktiver, der skal gemmes:",
    modal_save_selected: "Gem valgte",
    action_saved: "Gemt",
    modal_create_sprite_title: "Opret ny Sprite",
    modal_create_project_title: "Opret nyt projekt",
    modal_add_sheet_title: "Tilføj nyt ark",
    modal_rename_sheet_title: "Omdøb ark",
    modal_rename_sprite_title: "Omdøb Sprite",
    modal_delete_sprite_title: "Slet Sprite",
    modal_delete_project_title: "Slet projekt",
    modal_delete_sheet_title: "Slet ark",
    placeholder_sprite_name: "Navn",
    placeholder_project_name: "Navn",
    placeholder_sheet_name: "Navn",
    placeholder_new_name: "Nyt navn",
    action_create: "Skabe",
    action_add: "Tilføje",
    action_rename: "Omdøb",
    action_duplicate: "Duplikere",
    action_delete: "Slet",
    action_cancel: "Ophæve",
    confirm_delete_sprite: "Er du sikker på, at du vil slette denne sprite?",
    confirm_delete_project: "Er du sikker på, at du vil slette dette projekt? Alle sprites vil blive fjernet.",
    confirm_delete_sheet: "Er du sikker på, at du vil slette dette ark?",
    err_select_sprite: "Vælg venligst en sprite først.",
    err_select_project: "Vælg venligst et projekt først.",
    err_name_empty: "Navn må ikke være tomt.",
    err_sprite_exists: "En sprite med det navn findes allerede.",
    err_project_exists: "Et projekt med det navn findes allerede.",
    err_no_content: "Intet indhold at gemme.",
    err_no_changes: "Ingen ændringer at gemme.",
    err_delete_last_sheet: "Kan ikke slette det sidste ark.",
    err_extract_frames: "Kunne ikke udtrække nogen rammer.",
    err_indexeddb: "Kunne ikke gemme lokalt. Din browser understøtter muligvis ikke IndexedDB.",
    msg_upload_success: "Upload gennemført: {0}",
    msg_upload_failed: "Upload mislykkedes: {0}",
    msg_save_success: "Gem vellykket.",
    msg_saving: "Gemmer...",
    msg_multi_save_result: "Gemte {0} aktiver. {1} fejl.",
    menu_title: "Menu",
    menu_save: "Spare",
    menu_save_all: "Gem alle",
    menu_support: "Kontakt support",
    label_local_storage: "Lokal opbevaring",
    label_sign_in: "Log ind",
    modal_export_title: "Eksporter Sprite",
    label_filename: "Filnavn",
    label_format: "Format",
    action_export_confirm: "Eksportere",
};

export default translations;
